import React from 'react';
import { cn } from '../../utils/lib/utils';

/**
 * @typedef {Object} ToggleProps
 * @property {*} checked
 * @property {*} onCheckedChange
 * @property {*} disabled?
 * @property {*} className?
 */

export const Toggle = React.forwardRef(({
  checked,
  onCheckedChange,
  disabled = false,
  className,
  ...props
}, ref) => {
  return (
    <button
      ref={ref}
      type="button"
      role="switch"
      aria-checked={checked}
      data-state={checked ? 'checked' : 'unchecked'}
      disabled={disabled}
      onClick={() => onCheckedChange(!checked)}
      className={cn(
        'relative inline-flex h-6 w-11 items-center rounded-full transition-colors',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2',
        checked ? 'bg-primary' : 'bg-input',
        disabled && 'cursor-not-allowed opacity-50',
        className
      )}
      {...props}
    >
      <span
        className={cn(
          'pointer-events-none block h-5 w-5 rounded-full bg-background shadow-lg ring-0 transition-transform',
          checked ? 'translate-x-5' : 'translate-x-0'
        )}
      />
    </button>
  );
});
